var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23301 12.053C8.23301 12.038 8.23601 12.025 8.23701 12.01C8.24575 11.8131 8.32778 11.6265 8.46701 11.487L8.46901 11.484L14.116 5.83698C14.1903 5.76219 14.2786 5.70278 14.3759 5.66214C14.4731 5.62151 14.5775 5.60045 14.6829 5.60017C14.7883 5.5999 14.8927 5.6204 14.9902 5.66052C15.0877 5.70064 15.1763 5.75958 15.251 5.83398L15.533 6.11698C15.6831 6.26764 15.7672 6.47174 15.7668 6.68439C15.7664 6.89705 15.6816 7.10085 15.531 7.25098L10.729 12.052L15.529 16.853C15.6039 16.9272 15.6634 17.0155 15.7041 17.1127C15.7448 17.2099 15.7659 17.3142 15.7663 17.4196C15.7667 17.5251 15.7463 17.6295 15.7062 17.727C15.6662 17.8246 15.6073 17.9132 15.533 17.988L15.25 18.271C15.0991 18.4208 14.8948 18.5045 14.6822 18.5038C14.4695 18.503 14.2659 18.4179 14.116 18.267L8.74901 12.901L8.46601 12.618C8.31601 12.468 8.24001 12.273 8.23501 12.075L8.23301 12.053Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackicon);
export default __webpack_public_path__ + "static/media/backicon.356af7ba3c791e296000e20019b5e2f1.svg";
export { ForwardRef as ReactComponent };